package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.Size.Companion.vh
import com.downdogapp.client.MANIFEST
import com.downdogapp.client.Strings
import com.downdogapp.client.View
import com.downdogapp.client.controllers.WelcomeViewController
import com.downdogapp.client.resources.Images
import com.downdogapp.client.widget.*

actual class WelcomeView actual constructor(
  private val controller: WelcomeViewController
) : TopLevelView(), View {

  override val root =
    controllerView {
      bg = background(false, Images.LOGIN) {
        left = px(0)
        style.transform = "scale(1.25) translateY(-10%)"
      }

      fg = foreground(false) {
        verticalFlexBox(verticalJustify = JustifyContent.CENTER, horizontalAlign = AlignItems.CENTER) {
          height = vh(100)
          width = percent(100)

          imageView(Images.LOGIN_LOGO)
          MANIFEST.welcomeTitle?.let {
            label(it, 20) {
              marginTop = px(36)
            }
          }
          roundedTextButton(
            text = Strings.SIGN_UP,
            fontSize = 14,
            height = px(SignInViewConstants.roundedButtonHeight),
            clickFn = controller::onSignUpClicked
          ) {
            maxWidth = px(SignInViewConstants.contentWidth)
            marginTop = px(36)
            marginBottom = px(18)
          }
          roundedTextButton(
            text = Strings.LOG_IN,
            fontSize = 14,
            bgColor = Color.white(0.3),
            height = px(SignInViewConstants.roundedButtonHeight),
            clickFn = controller::onLogInClicked
          ) {
            maxWidth = px(SignInViewConstants.contentWidth)
          }
        }
      }
    }
}
